module.exports = __webpack_public_path__ + "assets/media/morning.38d7b048.mp3";